import React, { useMemo } from "react";
import { PeekListItemIcon, PeekListItemButton, PeekListItemText, PeekTypography, PeekListItem, PeekStack, useTheme, PeekBox, } from "@piiqtechnologies/ui-components";
export const NavigationListItem = ({ expanded, active, onClick, label, subLabel, Icon, color, }) => {
    const theme = useTheme();
    const textColor = useMemo(() => {
        if (active) {
            return color !== null && color !== void 0 ? color : "secondary.main";
        }
        return "primary.main";
    }, [active, color]);
    return (React.createElement(PeekListItem, { disablePadding: true, alignItems: "center", onClick: onClick },
        React.createElement(PeekListItemButton, { disableRipple: true, sx: {
                justifyContent: "initial",
                gap: 1.8,
                py: 0.5,
                px: 3,
                alignItems: "center",
            } },
            React.createElement(PeekListItemIcon, { sx: { minWidth: 0 } },
                React.createElement(PeekTypography, { variant: "body2", color: (active && color) || textColor, sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    } },
                    active && (React.createElement(PeekBox, { borderRadius: 2, sx: {
                            position: "absolute",
                            width: theme.spacing(2.8),
                            height: theme.spacing(2.8),
                            borderRadius: theme.spacing(0.6),
                            backgroundColor: color || "secondary.main",
                            opacity: 0.1,
                        } })),
                    React.createElement(Icon, null))),
            React.createElement(PeekStack, { direction: "row" },
                React.createElement(PeekListItemText, { primary: label, sx: {
                        opacity: expanded ? "1" : "0",
                        transition: "opacity .2s ease-out",
                        "-webkit-transition": "opacity .2s ease-out",
                        "-moz-transition": "opacity .2s ease-out",
                        "-o-transition": "opacity .2s ease-out",
                    }, primaryTypographyProps: {
                        variant: "h3",
                        fontWeight: "fontWeightRegular",
                        color: (active && color) || textColor,
                    } }),
                subLabel && (React.createElement(PeekTypography, { color: textColor, fontWeight: "fontWeightMedium", fontSize: "smaller", sx: { verticalAlign: "sup" } },
                    React.createElement("sup", null, subLabel)))))));
};
export default NavigationListItem;
